<template>
  <div class="e-menu-list-item-wrapper">
    <v-list-item
      class="e-menu-list-item"
      :class="computedClasses"
      :ripple="false"
      :input-value="inputValue"
      :value="value"
      :disabled="disabled"
      v-on="$listeners"
    >
      <template #default="{ active }">
        <div v-if="action" class="e-menu-list-item__action">
          <e-checkbox v-if="action === 'checkbox'" :input-value="active"></e-checkbox>
          <e-switch v-if="action === 'switch'" :input-value="active"></e-switch>
        </div>
        <div v-if="prependIcon" class="e-menu-list-item__prepend-icon">
          <e-icon>{{ prependIcon }}</e-icon>
        </div>
        <div class="e-menu-list-item__content">
          <div
            class="e-menu-list-item__content__title"
            :class="{ 'e-menu-list-item__content__title--small': description }"
          >
            <slot>
              {{ title }}
            </slot>
          </div>
          <div v-if="description" class="e-menu-list-item__content__description">{{ description }}</div>
        </div>
        <div v-if="appendIcon" class="e-menu-list-item__append-icon">
          <e-icon>{{ appendIcon }}</e-icon>
        </div>
      </template>
    </v-list-item>
  </div>
</template>
<script>
import { VListItem } from 'vuetify/lib'
export default {
  name: 'EMenuListItem',
  components: {
    VListItem,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: Boolean,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: undefined,
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return ['primary', 'danger'].includes(value)
      },
    },
    action: {
      type: String,
      default: '',
      validator: (v) => {
        return ['switch', 'checkbox', ''].includes(v)
      },
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    prependIcon: {
      type: String,
      default: '',
    },
    appendIcon: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedClasses() {
      return {
        [`e-menu-list-item--${this.variant}`]: true,
      }
    },
  },
}
</script>
